"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEARCH_HEIGHT = "55vh";
exports.SEARCH_FIELD_HEIGHT = "80px";
exports.SEARCH_LEGEND_HEIGHT = "30px";
//# sourceMappingURL=search.constants.js.map